export const ADD_ENVIRONMENT_WIZARD_TYPE = "add-environment";

/** Matches the environments the Projects page creates for a new project. */
export const NEW_PROJECT_ENVIRONMENTS = ["Production", "Development"];

export const NO_ADMIN_ACCESS_REASON =
  "Only account admins can add projects and environments";
